import { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu, X, MapPin, Phone, ChevronDown } from "lucide-react";
import ewLogo from "@/assets/ew-logo.png";

const serviceLinks = [
  { label: "Dedetização de Baratas", href: "/dedetizacao-baratas" },
  { label: "Dedetização de Formigas", href: "/dedetizacao-formigas" },
  { label: "Dedetização de Escorpiões", href: "/dedetizacao-escorpioes" },
  { label: "Dedetização de Mosquitos", href: "/dedetizacao-mosquitos" },
  { label: "Desratização", href: "/desratizacao" },
  { label: "Descupinização", href: "/descupinizacao" },
  { label: "Controle de Morcegos", href: "/controle-morcegos" },
  { label: "Sanitização", href: "/sanitizacao" },
  { label: "Limpeza de Caixa d'Água", href: "/limpeza-caixa-dagua" },
  { label: "Pulgas e Carrapatos", href: "/dedetizacao-pulgas-carrapatos" },
];

const navItems = [
  { label: "Home", href: "/" },
  { label: "A Empresa", href: "/sobre-nos" },
  { label: "Serviços", href: "/servicos", hasDropdown: true },
  { label: "Segmentos", href: "/segmentos" },
  { label: "Cidades Atendidas", href: "/locais" },
  { label: "Saúde Ambiental", href: "/controle-integrado-pragas" },
  { label: "Blog", href: "/blog" },
  { label: "Certificações", href: "/certificacoes" },
  { label: "Contato", href: "/contato" },
];

// Centralized city list with SEO-friendly URLs
const cityList: { name: string; href: string }[] = [
  { name: "Abreu e Lima", href: "/abreu-lima" },
  { name: "Aliança", href: "/dedetizacao-em-alianca" },
  { name: "Amaraji", href: "/dedetizacao-em-amaraji" },
  { name: "Belo Jardim", href: "/belo-jardim" },
  { name: "Bezerros", href: "/dedetizacao-em-bezerros" },
  { name: "Bom Conselho", href: "/bom-conselho" },
  { name: "Bom Jardim", href: "/dedetizacao-em-bom-jardim" },
  { name: "Bonito", href: "/dedetizacao-em-bonito" },
  { name: "Brejo da Madre de Deus", href: "/brejo-madre-deus" },
  { name: "Buenos Aires", href: "/dedetizacao-buenos-aires" },
  { name: "Cabo de Santo Agostinho", href: "/dedetizacao-no-cabo" },
  { name: "Camaragibe", href: "/camaragibe" },
  { name: "Camocim de São Félix", href: "/dedetizacao-camocim-sao-felix" },
  { name: "Carpina", href: "/dedetizacao-em-carpina" },
  { name: "Caruaru", href: "/dedetizacao-em-caruaru" },
  { name: "Casinhas", href: "/dedetizacao-em-casinhas" },
  { name: "Chã de Alegria", href: "/dedetizacao-cha-de-alegria" },
  { name: "Chã Grande", href: "/dedetizacao-cha-grande" },
  { name: "Cumaru", href: "/dedetizacao-em-cumaru" },
  { name: "Escada", href: "/dedetizacao-em-escada" },
  { name: "Feira Nova", href: "/dedetizacao-feira-nova" },
  { name: "Frei Miguelinho", href: "/dedetizacao-frei-miguelinho" },
  { name: "Glória do Goitá", href: "/dedetizacao-gloria-do-goita" },
  { name: "Goiana", href: "/dedetizacao-em-goiana" },
  { name: "Gravatá", href: "/dedetizacao-em-gravata" },
  { name: "Igarassu", href: "/igarassu" },
  { name: "Ipojuca", href: "/ipojuca" },
  { name: "Itaquitinga", href: "/dedetizacao-em-itaquitinga" },
  { name: "Jaboatão dos Guararapes", href: "/jaboatao-guararapes" },
  { name: "Jataúba", href: "/jatauba" },
  { name: "João Alfredo", href: "/dedetizacao-joao-alfredo" },
  { name: "Lagoa de Itaenga", href: "/dedetizacao-lagoa-de-itaenga" },
  { name: "Lagoa do Carro", href: "/dedetizacao-lagoa-do-carro" },
  { name: "Limoeiro", href: "/dedetizacao-em-limoeiro" },
  { name: "Macaparana", href: "/dedetizacao-em-macaparana" },
  { name: "Machados", href: "/dedetizacao-em-machados" },
  { name: "Moreno", href: "/dedetizacao-em-moreno" },
  { name: "Nazaré da Mata", href: "/dedetizacao-nazare-da-mata" },
  { name: "Olinda", href: "/olinda" },
  { name: "Orobó", href: "/dedetizacao-em-orobo" },
  { name: "Passira", href: "/dedetizacao-em-passira" },
  { name: "Paudalho", href: "/dedetizacao-em-paudalho" },
  { name: "Paulista", href: "/paulista" },
  { name: "Pocinhos", href: "/dedetizacao-em-pocinhos" },
  { name: "Pombos", href: "/dedetizacao-em-pombos" },
  { name: "Recife", href: "/recife" },
  { name: "Riacho das Almas", href: "/dedetizacao-riacho-das-almas" },
  { name: "Sairé", href: "/dedetizacao-em-saire" },
  { name: "Salgadinho", href: "/dedetizacao-em-salgadinho" },
  { name: "Santa Cruz do Capibaribe", href: "/dedetizacao-santa-cruz" },
  { name: "Santa Maria do Cambucá", href: "/dedetizacao-santa-maria-cambuca" },
  { name: "São Lourenço da Mata", href: "/dedetizacao-sao-lourenco" },
  { name: "São Vicente Ferrer", href: "/sao-vicente-ferrer" },
  { name: "Surubim", href: "/dedetizacao-em-surubim" },
  { name: "Timbaúba", href: "/dedetizacao-em-timbauba" },
  { name: "Toritama", href: "/dedetizacao-em-toritama" },
  { name: "Tracunhaém", href: "/dedetizacao-em-tracunhaem" },
  { name: "Umbuzeiro", href: "/dedetizacao-em-umbuzeiro" },
  { name: "Vertente do Lério", href: "/dedetizacao-vertente-do-lerio" },
  { name: "Vertentes", href: "/vertentes" },
  { name: "Vicência", href: "/dedetizacao-em-vicencia" },
  { name: "Vitória de Santo Antão", href: "/dedetizacao-em-vitoria" },
];

export { cityList };

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  const isActive = (href: string) => location.pathname === href;

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsServicesOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close dropdown on route change
  useEffect(() => {
    setIsServicesOpen(false);
    setIsMenuOpen(false);
    setIsMobileServicesOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 bg-background shadow-[var(--shadow-soft)]">
      {/* Top bar */}
      <div className="bg-primary text-primary-foreground py-1.5 hidden md:block">
        <div className="container mx-auto px-4 flex items-center justify-between text-sm">
          <div className="flex items-center gap-4">
            <a href="tel:+5581991343181" className="flex items-center gap-1 hover:opacity-80 transition-opacity">
              <Phone className="w-3 h-3" />
              (81) 99134-3181
            </a>
            <span className="opacity-60">|</span>
            <span className="flex items-center gap-1">
              <MapPin className="w-3 h-3" />
              +60 cidades em Pernambuco
            </span>
          </div>
          <Link
            to="/atendimento-imediato"
            className="bg-accent text-accent-foreground px-3 py-0.5 rounded text-xs font-bold hover:bg-accent/90 transition-colors animate-pulse"
          >
            🚨 ORÇAMENTO URGENTE
          </Link>
        </div>
      </div>

      <div className="container mx-auto px-3 sm:px-4 py-2 sm:py-3">
        <div className="flex items-center justify-between gap-2 sm:gap-4">
          <Link to="/" className="flex items-center flex-shrink-0">
            <img
              src={ewLogo}
              alt="Logo EW Saúde Ambiental"
              width={80}
              height={80}
              fetchPriority="high"
              decoding="async"
              className="h-14 sm:h-16 md:h-20 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) =>
              item.hasDropdown ? (
                <div key={item.href} className="relative" ref={dropdownRef}>
                  <button
                    onClick={() => setIsServicesOpen(!isServicesOpen)}
                    className={`text-sm font-medium px-2.5 py-1.5 rounded-md transition-colors whitespace-nowrap inline-flex items-center gap-1 ${
                      isActive(item.href) || isServicesOpen
                        ? "bg-primary/10 text-primary"
                        : "text-foreground hover:text-primary hover:bg-primary/5"
                    }`}
                  >
                    {item.label}
                    <ChevronDown className={`w-3.5 h-3.5 transition-transform ${isServicesOpen ? "rotate-180" : ""}`} />
                  </button>

                  {isServicesOpen && (
                    <div className="absolute top-full left-0 mt-1 bg-background border border-border rounded-lg shadow-lg py-2 w-64 z-50">
                      <Link
                        to="/servicos"
                        className="block px-4 py-2 text-sm font-semibold text-primary hover:bg-primary/5 transition-colors border-b border-border mb-1"
                      >
                        Ver Todos os Serviços
                      </Link>
                      {serviceLinks.map((service) => (
                        <Link
                          key={service.href}
                          to={service.href}
                          className={`block px-4 py-2 text-sm transition-colors ${
                            isActive(service.href)
                              ? "bg-primary/10 text-primary font-medium"
                              : "text-muted-foreground hover:text-primary hover:bg-primary/5"
                          }`}
                        >
                          {service.label}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`text-sm font-medium px-2.5 py-1.5 rounded-md transition-colors whitespace-nowrap ${
                    isActive(item.href)
                      ? "bg-primary/10 text-primary"
                      : "text-foreground hover:text-primary hover:bg-primary/5"
                  }`}
                >
                  {item.label}
                </Link>
              )
            )}
          </nav>

          {/* Mobile: urgente + menu */}
          <div className="flex items-center gap-2 lg:hidden">
            <Link
              to="/atendimento-imediato"
              className="bg-accent text-accent-foreground px-2 py-1 rounded text-xs font-bold animate-pulse"
            >
              🚨 Urgente
            </Link>
            <button
              className="text-foreground p-3 -mr-3 touch-manipulation"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden mt-3 pb-3 border-t border-border pt-3">
            <div className="flex flex-col gap-1">
              {navItems.map((item) =>
                item.hasDropdown ? (
                  <div key={item.href}>
                    <button
                      onClick={() => setIsMobileServicesOpen(!isMobileServicesOpen)}
                      className={`text-base font-medium w-full text-left py-3 px-2 rounded-lg flex items-center justify-between touch-manipulation transition-colors ${
                        isActive(item.href)
                          ? "bg-primary/10 text-primary"
                          : "text-foreground hover:text-primary hover:bg-muted"
                      }`}
                    >
                      {item.label}
                      <ChevronDown className={`w-4 h-4 transition-transform ${isMobileServicesOpen ? "rotate-180" : ""}`} />
                    </button>
                    {isMobileServicesOpen && (
                      <div className="ml-4 mt-1 mb-2 flex flex-col gap-0.5 border-l-2 border-primary/20 pl-3">
                        <Link
                          to="/servicos"
                          className="text-sm font-semibold text-primary py-2 block"
                          onClick={() => setIsMenuOpen(false)}
                        >
                          Ver Todos os Serviços
                        </Link>
                        {serviceLinks.map((service) => (
                          <Link
                            key={service.href}
                            to={service.href}
                            className="text-sm text-muted-foreground hover:text-primary py-2 block transition-colors"
                            onClick={() => setIsMenuOpen(false)}
                          >
                            {service.label}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <Link
                    key={item.href}
                    to={item.href}
                    className={`text-base font-medium w-full text-left py-3 px-2 rounded-lg block touch-manipulation transition-colors ${
                      isActive(item.href)
                        ? "bg-primary/10 text-primary"
                        : "text-foreground hover:text-primary hover:bg-muted"
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.label}
                  </Link>
                )
              )}

              <Link
                to="/atendimento-imediato"
                className="text-base font-bold w-full text-left py-3 px-2 rounded-lg block touch-manipulation text-accent hover:bg-accent/10 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                🚨 Orçamento Urgente
              </Link>

              <Button
                asChild
                size="lg"
                className="bg-secondary hover:bg-secondary/90 text-secondary-foreground flex items-center justify-center gap-2 text-base font-medium w-full mt-2 touch-manipulation"
                onClick={() => setIsMenuOpen(false)}
              >
                <a href="tel:+5581991343181" className="flex items-center gap-2">
                  <Phone className="w-5 h-5" />
                  (81) 99134-3181
                </a>
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
